import { ContactForm } from "../../components/marketing/contact-form";
import { MarketingLayout } from "../../components/marketing/marketing-layout";
import { contactContent } from "../../content/marketing/contact";
import { usePageMeta } from "../../hooks/use-page-meta";

export default function ContactPage() {
  usePageMeta(contactContent.metaTitle, contactContent.metaDescription);

  return (
    <MarketingLayout>
      <section className="mx-auto flex max-w-2xl flex-col gap-6 px-4 py-16 md:px-6">
        <div className="flex flex-col gap-4 text-center">
          <h1 className="font-bold font-display text-3xl">
            {contactContent.heading}
          </h1>
          <p className="text-base text-muted-foreground">
            {contactContent.intro}
          </p>
        </div>
        <ContactForm />
      </section>
    </MarketingLayout>
  );
}
